<template>

    <header>
        <div class="row-black no-padding-bottom clearfix">
            <div class="content-960">

                <div class="menu pull-left bt-mobile">
                    <div class="dropdown menu-mobile">
                        <!--MENU MOBILE-->
                        <b-dropdown class="text-white" variant="link" no-caret>
                            <b-dropdown-item v-canaccess="'/escolabox'">
                                <router-link to="/escolabox">Escolas</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/extratoescolabox'">
                                <router-link to="/extratoescolabox">Extrato de uso</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/colaboradorlogacesso'">
                                <router-link to="/colaboradorlogacesso">Log de Acesso</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/planoservico'">
                                <router-link to="/planoservico">Pacotes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/estoqueitem'">
                                <router-link to="/estoqueitem">Estoque</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/idioma'">
                                <router-link to="/idioma">Idioma</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/curso'">
                                <router-link to="/curso">Curso</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/nivel'">
                                <router-link to="/nivel">Nível</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/estagio'">
                                <router-link to="/estagio">Estágio</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tipoAvaliacao'">
                                <router-link to="/tipoAvaliacao">Tipo de Avaliação</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/midia'">
                                <router-link to="/midia">Mídia</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/campanha'">
                                <router-link to="/campanha">Campanha</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/contacorrentecarteira'">
                                <router-link to="/contacorrentecarteira">Contas Correntes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/banco'">
                                <router-link to="/banco">banco</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/bandeiracartao'">
                                <router-link to="/bandeiracartao">Bandeira de Cartão</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/empresaparceira'">
                                <router-link to="/empresaparceira">Empresa Parceira</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/categoriaempresaParceira'">
                                <router-link to="/categoriaempresaParceira">Categoria de Empresa Parceira</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/categoriaatendimento'">
                                <router-link to="/categoriaatendimento">Categoria de Atendimento</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/aliquotasimplesnacional'">
                                <router-link to="/aliquotasimplesnacional">Alíquota Simples Nacional</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/aliquotasimplesnacional'">
                                <router-link to="/aliquotasimplesnacional">Parâmetros</router-link>
                            </b-dropdown-item>

                        </b-dropdown>
                    </div>
                </div>

                <a href="/home" title="Logo CNA Portal Corporativo" class="logo-header">
                    <img src="../assets/imagens/logos/logo-CNA-big.png" alt="Imagem Logo CNA" title="CNA Jobs" class="logo-desktop" />
                    <img src="../assets/imagens/logos/logo-CNA-mobile.png" alt="Imagem Logo CNA" title="CNA Jobs" class="logo-mobile margin-ajust" />
                </a>

                <div class="user">
                    <div class="click-menu click-animate">
                        <div class="img-user">
                            <img :src="urlFoto" alt="Imagem do Usuário" :title="user.name" />
                        </div>
                        <h2>Olá, <span :title="user.name">{{user.name}}</span></h2>
                        <div class="cna-local">
                            <span :title="escolaNome">{{escolaNome}}</span>

                            <a class="icons-arrows" href="javascript:void(0);" @click="irParaPortalCorporativo()">
                                <span><br />Ir para Portal Corporativo</span>
                            </a>

                            <router-link to="/trocarescola" class="icons-arrows">
                                <span><br />Trocar escola</span>
                            </router-link>

                            <a class="float-right" style="cursor: pointer;" @click="logout()">
                                Sair
                            </a>

                        </div><br />
                    </div>
                    <div class="wrap-conteudo">
                        <div class="dados-user-mobile">
                            <h2>Olá, <span>{{user.name}}</span></h2>
                            <div class="cna-local">
                                {{escolaNome}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-desktop">
                    <ul class="style-hover">
                        <!--MENU DESKTOP-->
                        <li v-canaccess="'/home'">
                            <router-link to="/home">Home</router-link>
                        </li>

                        <b-nav-item-dropdown class="menu-color" v-canaccess="'/certificacoes'" text="Certificações Internacionais" left>

                            <b-dropdown-item v-canaccess="'/certificacoespoliticapreco'">
                                <router-link to="/certificacoespoliticapreco">POLÍTICA DE PREÇO</router-link>
                            </b-dropdown-item>
                            <b-dropdown-item v-canaccess="'/certificacoesregrasisencao'">
                                <router-link to="/certificacoesregrasisencao">REGRAS PARA ISENÇÃO</router-link>
                            </b-dropdown-item>

                        </b-nav-item-dropdown>
                        <b-nav-item-dropdown class="menu-color" text="CNA NA ESCOLA" left>

                            <b-dropdown-item v-canaccess="'/escolabox'">
                                <router-link to="/instituicaoensino">INSTITUIÇÕES DE ENSINO</router-link>
                            </b-dropdown-item>
                            <b-dropdown-item v-canaccess="'/escolabox'">
                                <router-link to="/instituicaoensinousuario">Gestão de Usuários</router-link>
                            </b-dropdown-item>

                        </b-nav-item-dropdown>

                        <b-nav-item-dropdown class="menu-color" text="MEU CNA" left>

                            <b-dropdown-item v-canaccess="'/ajudaperguntameucna'">
                                <router-link to="/ajudaperguntameucna">Perguntas e Respostas</router-link>
                            </b-dropdown-item>
                            <b-dropdown-item v-canaccess="'/ajudachamadomeucna'">
                                <router-link to="/ajudachamadomeucna">Gestão de Chamados</router-link>


                            </b-dropdown-item>

                        </b-nav-item-dropdown>

                        <b-nav-item-dropdown class="menu-color" text="CNA BOX" left>

                            <b-dropdown-item v-canaccess="'/escolabox'">
                                <router-link to="/escolabox">Escolas</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/extratoescolabox'">
                                <router-link to="/extratoescolabox">Extrato de uso</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/colaboradorlogacesso'">
                                <router-link to="/colaboradorlogacesso">Log de Acesso</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/planoservico'">
                                <router-link to="/planoservico">Pacotes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/estoqueitem'">
                                <router-link to="/estoqueitem">Estoque</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/idioma'">
                                <router-link to="/idioma">Idioma</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/curso'">
                                <router-link to="/curso">Curso</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/nivel'">
                                <router-link to="/nivel">Nível</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/estagio'">
                                <router-link to="/estagio">Estágio</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tipoAvaliacao'">
                                <router-link to="/tipoAvaliacao">Tipo de Avaliação</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/midia'">
                                <router-link to="/midia">Mídia</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/campanha'">
                                <router-link to="/campanha">Campanha</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/contacorrentecarteira'">
                                <router-link to="/contacorrentecarteira">Contas Correntes</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/banco'">
                                <router-link to="/banco">banco</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/bandeiracartao'">
                                <router-link to="/bandeiracartao">Bandeira de Cartão</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/empresaparceira'">
                                <router-link to="/empresaparceira">Empresa Parceira</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/categoriaempresaParceira'">
                                <router-link to="/categoriaempresaParceira">Categoria de Empresa Parceira</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/categoriaatendimento'">
                                <router-link to="/categoriaatendimento">Categoria de Atendimento</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/aliquotasimplesnacional'">
                                <router-link to="/aliquotasimplesnacional">Alíquota Simples Nacional</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/parametro'">
                                <router-link to="/parametro">Parâmetros</router-link>
                            </b-dropdown-item>

                            <b-dropdown-divider></b-dropdown-divider>

                            <b-dropdown-item v-canaccess="'/tutorialvideofuncionalidade'">
                                <router-link to="/tutorialvideofuncionalidade">Funcionalidades dos Vídeos</router-link>
                            </b-dropdown-item>

                            <b-dropdown-item v-canaccess="'/tutorialvideo'">
                                <router-link to="/tutorialvideo">Novo Vídeo</router-link>
                            </b-dropdown-item>

                        </b-nav-item-dropdown>

                    </ul>
                </div>
            </div>
        </div>
    </header>

</template>
<script>

    import Global from '@/common/global'
    import Auth from '@/common/auth'

    export default {
        name: "header-cna",
        data() {
            return {
                urlPortalCorporativo: Global.URL_PORTAL_CORPORATIVO,
                user: { escolas: [] },
                foto: '',
            }
        },
        computed: {
            urlFoto() {
                return Global.URL_DOWNLOAD + "colaborador-foto/" + this.foto + "?v=" + Math.random();
            },
            escolaNome() {
                var escola = this.user.escolas.filter(_ => _.escolaId == +this.user.tenant)[0];
                if (escola) return escola.nomeEscola
                return "--";
            }
        },
        methods: {
            irParaPortalCorporativo: function () {
                sessionStorage.clear();
                window.location = this.urlPortalCorporativo;
            },
            logout: function () {
                Auth.logout()
            },
        },
        mounted() {
            this.user = Auth.currentUser();
            this.foto = Auth.getFotoUser();
        },

    };
</script>